import { SEND_COMMUNICATION_360, SEND_COMMUNICATION_360_SUCCESS, SEND_COMMUNICATION_360_ERROR, SEND_COMMUNICATION_360_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SendCommunication360 = (state = initialState, action) => {
  switch (action.type) {
    case SEND_COMMUNICATION_360:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_COMMUNICATION_360_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_COMMUNICATION_360_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_COMMUNICATION_360_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SendCommunication360;
